import React, { useEffect, useState } from "react";
import "./generate.css";
import { toast } from "react-toastify";
import AddApi from "../addApi/AddApi";
import download from "./download.webp";
import Chat from "../chat/Chat";

const Generate = () => {
  const [images, setImages] = useState([]);
  const [textInput, setTextInput] = useState("");
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const [isShowImages, setShowImages] = useState(true);
  const [isAddApi, setAddApi] = useState(false);
  const [addClass, setAddClass] = useState(false);

  const storedAddApi = sessionStorage.getItem("AddApi");

  const apiKey = storedAddApi;

  const handleGenerate = async () => {
    if (textInput.trim() === "") {
      toast.error("Please enter a value.");
      return;
    }
    if (!storedAddApi || storedAddApi == "") {
      toast.error("You must add the openai api");

      setAddApi(true);
      return;
    }

    setButtonDisabled(true);

    setAddClass(true);

    const methods = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiKey}`,
      },
      body: JSON.stringify({
        prompt: textInput,
        n: 2,
        size: "256x256",
      }),
    };

    const response = await fetch(
      "https://api.openai.com/v1/images/generations",
      methods
    );

    if (response.ok) {
      const dataRes = await response.json();

      toast.success("Images generated successfully");

      setShowImages(false);

      setButtonDisabled(false);

      setTextInput("");

      setAddClass(false);

      setImages(dataRes.data);
    } else {
      const errorData = await response.json();
      toast.error(errorData.error.message);
      setAddClass(false);
      setButtonDisabled(false);
    }
  };

  const handleEditApi = () => {
    setAddApi(true);
  };

  const downloadImage = async (url, imageName) => {
    const link = document.createElement("a");
    link.href = await url;
    link.target = "_blank";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      {isAddApi && <AddApi setAddApi={setAddApi} />}

      <Chat setAddApi={setAddApi} />

      <div className="images_generator">
        <h2>AI Images Generator</h2>

        <div className="images">
          {isShowImages ? (
            <>
              <div className={addClass ? "rotate624" : ""}></div>
              <div className={addClass ? "rotate624" : ""}></div>
            </>
          ) : (
            images.map((image, index) => (
              <div key={index} className={addClass ? "rotate624" : ""}>
                <img
                  className="downloadImage"
                  src={download}
                  alt={`image_${index}`}
                  onClick={() => downloadImage(image.url)}
                />

                <img
                  className="image_response"
                  src={image.url}
                  alt={`Generated Image ${index}`}
                />
              </div>
            ))
          )}
        </div>

        <div className="propmt">
          <input
            type="text"
            value={textInput}
            onChange={(e) => setTextInput(e.target.value)}
          />
          <button onClick={handleGenerate} disabled={isButtonDisabled}>
            Generate
          </button>
        </div>

        {storedAddApi && <button onClick={handleEditApi}>EditApi</button>}
      </div>
    </>
  );
};

export default Generate;
